import { render, staticRenderFns } from "./UnavailableManage.vue?vue&type=template&id=2ebfed14&scoped=true"
import script from "./UnavailableManage.vue?vue&type=script&lang=js"
export * from "./UnavailableManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebfed14",
  null
  
)

export default component.exports